import LineLoader from '../../assets/loader/lineLoader.svg';

const SimpleLoader = () => {
    return (
        <>
            <div className="flex flex-col justify-center items-center w-full h-full">
               <img src={LineLoader} />
               <p className='text-lg mb-0 font-semibold mt-3 secondary-text'>Loading data</p>
            </div>
        </>
    );
}

export default SimpleLoader;
